import React from "react";

import { appConstants } from "../../config/app-constants";

type Props = {};

const LTAAllowanceHint: React.FC<Props> = (props: Props) => {
	return (
		<>
			<section className="text-center">
				<img
					src={`${appConstants.basePath}/assets/images/hints/lta-allowance.png`}
					alt="LTA"
					className="img-fluid d-block mx-auto my-4"
				/>
			</section>
		</>
	);
};

export default LTAAllowanceHint;
